"use client";
import React, { useMemo } from "react";
import "./AddSchema.css";
import { FaEdit, FaTrash, FaSave } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import AddField from "./AddModel/AddField";
import AddRules from "./AddModel/AddRules";
import { IoAddSharp } from "react-icons/io5";
import { FaEye } from "react-icons/fa";
import { IoMdEyeOff } from "react-icons/io";
import { IoIosArrowBack } from "react-icons/io";
import useAddSchemaLogic from "./AddSchemaLogic";
import { useLocation } from "react-router-dom";
import { useCustomContext } from "../../CustomComponents/CustomComponents";

function RenderNestedFields({
  fields,
  parentPath,
  nestedFieldsMap,
  rulesMap,
  openNestedLists,
  openRulesLists,
  toggleNestedList,
  toggleRulesList,
  handleAddNestedField,
  handleOpenAddRuleModal,
  handleDeleteNestedField,
  handleEditMainField,
  handleDeleteRule
}) {
  const pathToKey = (p) => (Array.isArray(p) ? p.join("-") : String(p));
  return (
    <div className="render-nested-level" style={{ marginTop: 8 }}>
      <div className="edit1-table-content">
        <table className="table ">
          <thead className="thead-dark">
            <tr>
              <th>Field Name</th>
              <th>Data Type</th>
              <th>UI Type</th>
              <th>Label</th>
              <th>Visibility</th>
              <th>Source</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {fields.map((field, idx) => {
              const thisPathArr = [...parentPath, idx];
              const thisKey = pathToKey(thisPathArr);
              const children = nestedFieldsMap[thisKey];

              return (
                <React.Fragment key={thisKey}>
                  <tr>
                    <td style={{ paddingLeft: `${parentPath.length * 18}px` }}>{field.field_name}</td>
                    <td>{field.data_type}</td>
                    <td>{field.ui_type}</td>
                    <td>{field.label}</td>
                    <td>{field.visibility}</td>
                    <td>{field.source}</td>
                    <td>
                      <span className="edit1-action-icon" style={{ display: "flex", gap: 8, alignItems: "center" }}>
                        {(field.data_type === "group" || field.data_type === "list") ? (
                          <>
                            <IoAddSharp
                              style={{ cursor: "pointer", fontSize: 20, color: "#09c" }}
                              onClick={() => handleAddNestedField(thisPathArr)}
                              title="Add Field"
                            />

                            {children && children.length > 0 && (
                              <>
                                {openNestedLists[thisKey] ? (
                                  <IoMdEyeOff
                                    style={{ cursor: "pointer", fontSize: 18, color: "#09c" }}
                                    onClick={() => toggleNestedList(thisKey)}
                                    title="Collapse Nested Fields"
                                  />
                                ) : (
                                  <FaEye
                                    style={{ cursor: "pointer", fontSize: 18, color: "#09c" }}
                                    onClick={() => toggleNestedList(thisKey)}
                                    title="Expand Nested Fields"
                                  />
                                )}
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <IoAddSharp
                              style={{ cursor: "pointer", fontSize: 20, color: "#09c" }}
                              onClick={() => handleOpenAddRuleModal(thisPathArr)}
                              title="Add Rule"
                            />
                            {rulesMap[thisKey] && rulesMap[thisKey].length > 0 && (
                              <>
                                {openRulesLists[thisKey] ? (
                                  <IoMdEyeOff
                                    style={{ cursor: "pointer", fontSize: 18, color: "#09c" }}
                                    onClick={() => toggleRulesList(thisKey)}
                                    title="Collapse Rules"
                                  />
                                ) : (
                                  <FaEye
                                    style={{ cursor: "pointer", fontSize: 18, color: "#09c" }}
                                    onClick={() => toggleRulesList(thisKey)}
                                    title="Expand Rules"
                                  />
                                )}
                              </>
                            )}
                          </>
                        )}

                        <FaEdit className="Edit-Trash-icon" onClick={() => handleEditMainField(thisPathArr)} />
                        <FaTrash className="Edit-Trash-icon" onClick={() => handleDeleteNestedField(thisPathArr)} />
                      </span>
                    </td>
                  </tr>

                  {/* Rules table */}
                  {rulesMap[thisKey] && rulesMap[thisKey].length > 0 && openRulesLists[thisKey] && (
                    <tr>
                      <td colSpan="7">
                        {openRulesLists[thisKey] && (
                          <div className="">
                            <div style={{ padding: "8px" }}>
                              <div className="rules-table-container">
                                <table className="table-hovered">
                                  <thead>
                                    <tr>
                                      <th>Rule Type</th>
                                      <th>Pattern</th>
                                      <th>Compare Field</th>
                                      <th>Operator</th>
                                      <th>Min</th>
                                      <th>Max</th>
                                      <th>Message</th>
                                      <th>Actions</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {rulesMap[thisKey].map((r, ri) => (
                                      <tr key={ri}>
                                        <td>{r.type || "-"}</td>
                                        <td>{r.pattern || "-"}</td>
                                        <td>{r.compare_field || "-"}</td>
                                        <td>{r.operator || "-"}</td>
                                        <td>{r.min ?? "-"}</td>
                                        <td>{r.max ?? "-"}</td>
                                        <td>{r.message || "-"}</td>
                                        <td>
                                          <FaEdit
                                            className="Edit-Trash-icon"
                                            style={{ marginRight: 8 }}
                                            onClick={() => handleOpenAddRuleModal(thisPathArr, ri)}
                                          />
                                          <FaTrash
                                            className="Edit-Trash-icon"
                                            onClick={() => handleDeleteRule(thisPathArr, ri)}
                                          />
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  )}

                  {/* nested children recursive -  Shows child fields when expanded*/}
                  {(field.data_type === "group" || field.data_type === "list") && children && children.length > 0 && (
                    <tr>
                      <td colSpan="7" style={{ background: "#fff" }}>
                        <div style={{ marginTop: 8 }}>

                          {openNestedLists[thisKey] && (
                            <div className="nested-scroll-container">
                              <RenderNestedFields
                                fields={children}
                                parentPath={thisPathArr}
                                nestedFieldsMap={nestedFieldsMap}
                                rulesMap={rulesMap}
                                openNestedLists={openNestedLists}
                                openRulesLists={openRulesLists}
                                toggleNestedList={toggleNestedList}
                                toggleRulesList={toggleRulesList}
                                handleAddNestedField={handleAddNestedField}
                                handleOpenAddRuleModal={handleOpenAddRuleModal}
                                handleDeleteNestedField={handleDeleteNestedField}
                                handleEditMainField={handleEditMainField}
                                handleDeleteRule={handleDeleteRule}
                              />
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
//Main Component Add Schema
function AddSchema({ showIconsOnly }) {
  const location = useLocation();
  // useMemo ensures this only runs when location changes
  const initialSchema = useMemo(() => location?.state?.schemaToEdit ?? null, [location?.state]);
  const { showAlert, stopHudRotation, hud, showToast } = useCustomContext();


  const {
    // Modal visibility
    openAddModel,
    openAddRuleModal,
    openJSONModal,

    // Data
    mainFieldsList,
    nestedFieldsMap,
    rulesMap,
    datasetIdList,
    schemaFormData,
    jsonSchema,

    // Status
    isJSONSaved,
    isMainListOpen,
    isEditMode,

    // UI state
    openNestedLists,
    openRulesLists,
    editingFieldPath,
    schemaErrors,

    // JSON editing
    isJSONEditMode,
    jsonText,

    // Handlers - Form
    handleSchemaFormChange,

    // Handlers - Field modal
    handleOpenAddModel,
    handleCloseAddModel,
    handleSaveMainField,
    handleEditMainField,
    handleDeleteMainField,
    handleAddNestedField,
    handleDeleteNestedField,

    // Handlers - Toggles
    toggleMainList,
    toggleNestedList,
    toggleRulesList,

    // Handlers - Rules modal
    handleOpenAddRuleModal,
    handleCloseRulesModal,
    handleSaveRule,
    handleDeleteRule,
    getExistingRuleForEdit,

    // Handlers - JSON
    handleGenerateJSON,
    handleFinalSave,

    downloadJSON,
    setOpenJSONModal,

    // Handlers - JSON editing
    handleEnableJSONEdit,
    handleJsonChange,
    handleCancelJSONEdit,
    handleSaveJSONEdit,

    // Handlers - Navigation
    handleBackNavigation,

    // Utilities
    getAllFieldNames,
    getExistingFieldForEdit,
    handleCloseJSONModal,
    isDatasetOpen,
    setIsDatasetOpen,
    MdKeyboardArrowDown,
    MdKeyboardArrowUp,
    hoveredDataset, 
    setHoveredDataset,
  } = useAddSchemaLogic(initialSchema);


  return (
    <div className={`main-content ${showIconsOnly ? "icons-only" : ""}`}>
      {/* Back button + Unsaved changes warning */}
      <div className="p-3 custom-bg-dataset1 rounded">
        <div className="back-navigation">
          <button
            type="button"
            className="back-btn"
            onClick={handleBackNavigation}
          > <IoIosArrowBack />
            Back
          </button>

          {!isJSONSaved && (
            <div className="warning-banner">
              Please do not refresh the page until you generate and {isEditMode ? 'update' : 'save'} the JSON.
            </div>
          )}
        </div>
        <form className="filter-row1" onSubmit={(e) => e.preventDefault()}>

          {/* Schema Name */}
          <div className="filter-item1 input-text-enter2">
            <label>
              Schema Name <span style={{ color: "#dc3545" }}>*</span>
            </label>
            <input
              type="text"
              name="schema_name"
              className={`form-control small-placeholder ${schemaErrors?.schema_name ? "input-addfield-error" : ""
                }`}
              placeholder="Enter Schema Name"
              value={schemaFormData.schema_name}
              onChange={handleSchemaFormChange}
            />
            {schemaErrors?.schema_name && (
              <span className="error-addfield">{schemaErrors.schema_name}</span>
            )}
          </div>

          {/* Label */}
          <div className="filter-item1 input-text-enter2">
            <label>
              Label <span style={{ color: "#dc3545" }}>*</span>
            </label>
            <input
              type="text"
              name="label"
              className={`form-control small-placeholder ${schemaErrors?.label ? "input-addfield-error" : ""
                }`}
              placeholder="Enter Label"
              value={schemaFormData.label}
              onChange={handleSchemaFormChange}
            />
            {schemaErrors?.label && (
              <span className="error-addfield">{schemaErrors.label}</span>
            )}
          </div>

          {/* Purpose */}
          <div className="filter-item1">
            <label>
              Purpose <span style={{ color: "#dc3545" }}>*</span>
            </label>
            <select
              className={`form-select ${schemaErrors?.purpose ? "input-addfield-error" : ""
                }`}
              name="purpose"
              value={schemaFormData.purpose}
              onChange={handleSchemaFormChange}
            >
              <option value="">Select</option>
              <option value="Search">search</option>
              <option value="entry">entry</option>
              <option value="case splitter">case splitter</option>
              <option value="case redaction">case redaction</option>
            </select>
            {schemaErrors?.purpose && (
              <span className="error-addfield">{schemaErrors.purpose}</span>
            )}
          </div>

          {/* Dataset ID */}
          <div className="filter-item1">
            <label>Dataset ID</label>
            <div className="custom-select-AS">
              <div
                className="custom-select-trigger-AS"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsDatasetOpen(prev => !prev);
                  setHoveredDataset(null);
                }}>
                <span className={!schemaFormData.dataset_id ? "placeholder-AS" : ""}>
                  {schemaFormData.dataset_id || "Select"}
                </span>
                <span className="dropdown-icon-AS">
                  {isDatasetOpen ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
                </span>
              </div>
              {isDatasetOpen && (
                <div
                  className="custom-select-dropdown-AS"
                  onWheel={(e) => e.stopPropagation()}>
                  <div
                    className={`custom-option-AS placeholder-AS ${hoveredDataset === null && !schemaFormData.dataset_id
                        ? "selected-option-AS"
                        : hoveredDataset === ""
                          ? "selected-option-AS"
                          : ""
                      }`}
                    onMouseEnter={() => setHoveredDataset("")}
                    onClick={() => {
                      handleSchemaFormChange({ target: { name: "dataset_id", value: "" } });
                      setIsDatasetOpen(false);
                      setHoveredDataset(null);
                    }}>
                    <option value="">Select</option>
                  </div>
                  {datasetIdList.map((ds, i) => (
                    <div
                      key={i}
                      className={`custom-option-AS ${hoveredDataset === ds.datasetID
                          ? "selected-option-AS"
                          : hoveredDataset === null && schemaFormData.dataset_id === ds.datasetID
                            ? "selected-option-AS"
                            : ""
                        }`}
                      onMouseEnter={() => setHoveredDataset(ds.datasetID)}
                      onClick={() => {
                        handleSchemaFormChange({
                          target: {
                            name: "dataset_id",
                            value: ds.datasetID
                          }
                        });
                        setIsDatasetOpen(false);
                        setHoveredDataset(null);
                      }}>
                      {ds.datasetID}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Enabled */}
          <div className="filter-item1 schema-enabled-field">
            {/* <label>Enabled</label> */}
            <div className="schema-enabled-checkbox">
              <input
                id="schema-enabled"
                type="checkbox"
                name="enabled"
                checked={!["false", "0", "no", "disabled"].includes(String(schemaFormData.enabled).trim().toLowerCase())}
                onChange={handleSchemaFormChange}
              />
              <label htmlFor="schema-enabled">Enabled</label>
            </div>
          </div>

          {/* Add Fields */}
          <div className="filter-item1">
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                handleOpenAddModel(null, null);
              }}
            >
              Add Fields
            </button>
          </div>

        </form>

      </div>
      {/* Displays all fields in nested structure */}
      <div className="custom-bg-white edit1-main-content-2 mt-4 p-3">
        <div className="edit1-accordion-item mt-2">
          {isMainListOpen && (
            <div className="edit1-accordion-content">

              <div className="edit1-table-content">
                {mainFieldsList.length === 0 ? (
                  <div className="text-center">No Fields Added</div>
                ) : (
                  <RenderNestedFields
                    fields={mainFieldsList}
                    parentPath={[]}
                    nestedFieldsMap={nestedFieldsMap}
                    rulesMap={rulesMap}
                    openNestedLists={openNestedLists}
                    openRulesLists={openRulesLists}
                    toggleNestedList={toggleNestedList}
                    toggleRulesList={toggleRulesList}
                    handleAddNestedField={handleAddNestedField}
                    handleOpenAddRuleModal={handleOpenAddRuleModal}
                    handleDeleteNestedField={handleDeleteNestedField}
                    handleEditMainField={handleEditMainField}
                    handleDeleteRule={handleDeleteRule}
                  />
                )}
              </div>
            </div>
          )}
        </div>
        <div className="save-btn-wrapper">
          <button className="edit1-final-save-btn" onClick={handleGenerateJSON}>
            <FaSave className="edit1-save-icon" />
            Generate CK_Schema
          </button>
        </div>
      </div>

      {/* Add/Edit Field model */}
      {openAddModel && (
        <AddField
          onCancel={handleCloseAddModel}
          onSave={handleSaveMainField}
          editData={editingFieldPath ? getExistingFieldForEdit() : null}
        />
      )}
      {/* Add/Edit Rule model */}
      {openAddRuleModal && (
        <AddRules
          onCancel={handleCloseRulesModal}
          onSave={handleSaveRule}
          editData={getExistingRuleForEdit()}
          fieldOptions={getAllFieldNames()}
        />
      )}
      {/* MODAL for JSON Preview/Edit Shows json edit, download, save options */}
      {openJSONModal && (
        <div className="edit1-modal-backdrop">
          <div className="edit1-modal">
            <div className="edit1-modal-header">
              <span>
                Generated CK_Schema JSON: ({schemaFormData.schema_name || "No Name"})
              </span>
              <div className="json-header-actions">
                {!isJSONEditMode ? (
                  /* ---- VIEW MODE BUTTONS ---- */
                  <>
                    <button
                      className="json-ed"
                      onClick={() => downloadJSON(jsonSchema)}
                    >
                      Download
                    </button>
                    <button
                      className="json-ed primary"
                      onClick={handleEnableJSONEdit}
                    >
                      Edit
                    </button>
                    <button
                      className="json-ed "
                      onClick={() => handleFinalSave(jsonSchema)}>
                      {isEditMode ? 'Update' : 'Save'}
                    </button>
                  </>
                ) : (
                  /* ---- EDIT MODE BUTTONS ---- */
                  <>
                    <button
                      className="json-ed"
                      onClick={() => downloadJSON(jsonSchema)}
                    >
                      Download
                    </button>

                    <button
                      className="json-ed primary"
                      onClick={handleSaveJSONEdit}
                    >
                      Save
                    </button>
                  </>
                )}
              </div>
              <MdClose
                size={20}
                className="AF-closeBtn"
                onClick={handleCloseJSONModal}
              />
            </div>

            <div className={`edit1-modal-body ${isJSONEditMode ? "no-body-scroll" : ""}`}>
              {/* ---- READ-ONLY VIEW ---- */}
              {!isJSONEditMode && (
                <pre className="edit1-json-preview">
                  {JSON.stringify(jsonSchema, null, 2)}
                </pre>
              )}

              {isJSONEditMode && (
                <div className="json-editor-container">
                  <MdClose
                    size={20}
                    className="json-cancel-inside"
                    onClick={handleCancelJSONEdit}
                  />
                  <textarea
                    className="json-editor1"
                    value={jsonText}
                    onChange={handleJsonChange}
                  />
                </div>
              )}

              {/* Error Message */}
              {schemaErrors.json && (
                <p className="error-text" style={{ color: 'red', marginTop: '10px' }}>
                  {schemaErrors.json}
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AddSchema;
